import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {Content} from '@builder.io/sdk-react'
import {getPreviewBlocks} from './utils'
import {customComponents} from 'hec/builder'
import AccountDrawer from 'hec/builder/blocks/account-drawer/accountDrawerBlock'

const LessonContentPreview = ({content, config, builderModel, showFull, onReadMoreClick}) => {
    const previewBlocks = useMemo(() => getPreviewBlocks(content?.data?.blocks || [], 1), [content])
    const fullContent = (
        <Content
            model={builderModel}
            content={content}
            apiKey={config.app.builder.api}
            customComponents={customComponents}
        />
    )

    const previewContent = (
        <div className="relative max-h-[9rem] overflow-hidden">
            <Content
                model={builderModel}
                content={{
                    ...content,
                    data: {
                        ...content.data,
                        blocks: previewBlocks
                    }
                }}
                apiKey={config.app.builder.api}
                customComponents={customComponents}
            />
            <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-white/100 to-transparent pointer-events-none" />
        </div>
    )

    return <div>{showFull ? fullContent : previewContent}</div>
}

export default LessonContentPreview

LessonContentPreview.propTypes = {
    content: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    builderModel: PropTypes.string.isRequired,
    showFull: PropTypes.bool.isRequired,
    onReadMoreClick: PropTypes.func.isRequired
}
